<div
  class="active-tasks-container"
  #dragScrollContainer
  (mousedown)="startDragging($event)"
  (mouseup)="stopDragging($event)"
  (mouseleave)="stopDragging($event)"
  (mousemove)="moveEvent($event)"
>
  @for (task of tasks; track task) {
    <current-sked-task-list-default-theme-active-task
      [task]="task"
      [project]="projectsMap[task.projectId]"
      (click)="onTaskClick(task._id)"
    ></current-sked-task-list-default-theme-active-task>
  }
</div>
